// extracted by mini-css-extract-plugin
module.exports = {"error":"Error_error__1MUrL","text":"Error_text__12Koy"};